import { CdkAccordionItem } from '@angular/cdk/accordion';
import {
  Component,
  EventEmitter,
  Input,
  Output,
  QueryList,
  ViewChildren,
  ChangeDetectionStrategy,
} from '@angular/core';
import { NavigationItem } from '@digilize/shared/definitions/src';
import { isTablet } from '@digilize/shared/utils/helpers/src';

@Component({
  selector: 'lib-dash-navigation',
  templateUrl: './dash-navigation.component.html',
  styleUrls: ['./dash-navigation.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class DashNavigationComponent {
  @ViewChildren(CdkAccordionItem) accordionItems!: QueryList<CdkAccordionItem>;

  @Input() dashboardMenuUncollapsed: boolean;
  @Input() navItems: NavigationItem[];
  @Output() collapseChange = new EventEmitter<boolean>();

  /* A stable key per item so rebuilding `navItems` reuses the existing DOM. Without it every rebuild
     re-creates the cdk-accordion-items, closing any open group and shifting the items under the
     pointer. Data-labelled items (`label`) can share a translation key, so their route is the key;
     it also keeps them in place when a language switch changes the label. */
  trackByKey(_index: number, item: NavigationItem): string {
    return item.label !== undefined && item.route ? item.route : item.translation;
  }

  toggleSidebarCollapse() {
    if (this.dashboardMenuUncollapsed) {
      this.closeAll();
    }
    this.dashboardMenuUncollapsed = !this.dashboardMenuUncollapsed;
    this.collapseChange.emit(this.dashboardMenuUncollapsed);
  }

  private closeAll() {
    this.accordionItems.forEach((item) => item.close());
  }

  public interacted(accordionItem: CdkAccordionItem) {
    if (!this.dashboardMenuUncollapsed) {
      this.closeAll();
    }
    if (isTablet() && this.dashboardMenuUncollapsed) {
      this.collapseChange.emit(false);
    }
  }

  public handleClickOutside(accordionItem: CdkAccordionItem) {
    if (isTablet()) {
    } else {
    }
  }
}
